@if (!isiFrame) {
  <div class="footer-wrapper">
    <div class="footer-container">
      <div class="logo-section">
        <img
          class="intel-logo"
          src="/assets/brand/intel-logo-{{ theme() }}.svg"
          alt="Intel Logo"
        />
      </div>
      <div class="content-section">
        <div class="links">
          <hyperkit-button
            routerLink="/customer-support"
            variant="link"
            color="primary"
            text="Support"
          ></hyperkit-button>
          <hyperkit-button
            routerLink="/privacy-policy"
            variant="link"
            color="primary"
            text="Privacy Policy"
          ></hyperkit-button>
          <hyperkit-button
            routerLink="/terms-and-conditions"
            variant="link"
            color="primary"
            text="Terms and Conditions"
          ></hyperkit-button>
        </div>
        <div class="copyright">
          <hyperkit-typography variant="emphasized" size="sm" color="primary">
            Copyright © {{ date }} Intel 471. All Rights Reserved
          </hyperkit-typography>
        </div>
      </div>
    </div>
  </div>
}
